<template>
  <!-- 服务商 -->
  <div class="serviceProvider">
    <div class="service">服务商</div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="item.title" :name="(index * 1 + 1).toString()" v-for="(item, index) in serviceTypeList"
        :key="index">
        <el-carousel :interval="5000" arrow="always" class="service-box" trigger="click" v-if="index + 1 == activeName">
          <div class="empty" v-if="serviceList.length == 0">暂无数据</div>
          <el-carousel-item v-for="(content, index) in serviceList" :key="index">
            <div class="serviceItem">
              <div class="serviceItem-bg" :style="{ backgroundImage: `url(${content['pic']})` }"></div>
              <div class="serviceItem-con">
                <div class="wrap1">
                  <div class="wrap1-title">{{ content["title"] }}</div>
                  <div class="wrap1-url">{{ content["url"] }}</div>
                </div>
                <div class="wrap2 over-num-lines num4-lines">{{ content["description"] }}</div>
                <div class="wrap3">
                  <div class="wrap3-con">
                    服务能力：
                    <div class="ability" v-for="(item, i) in content['capabilityList']" :key="i">
                      <span v-if="i < content['capabilityList'].length - 1" class="abilityText">{{ item.title }}</span>
                      <span v-else class="abilityText">{{ item.title }}</span>
                    </div>
                  </div>
                  <div style="margin-top: 50px;">
                    典型案例：
                    <span v-for="(item, i) in content['caseList']" :key="i" @click="goCaseDetail(item.uuid)"
                      class="curp">
                      <span v-if="i < content['caseList'].length - 1">{{ item.title + "、" }}</span>
                      <span v-else>{{ item.title }}</span>
                    </span>
                  </div>
                  <div style="font-weight:normal">联系方式：
                    {{ content["linkMethod"] }}</div>
                </div>
                <div class="wrap4 curp" @click="onClickDetail(content['uuid'])">
                  查看详情 >
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getServiceTypeList, getServiceList } from "../../utils/interface"
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      activeName: "1",
      serviceTypeList: [{ title: "智能制造集成" }, { title: "软件开发与设计" }], // 服务商分类
      serviceList: [
        // {
        //   title: "宁夏菲麦森工业软件技术有限公司",
        //   pic:
        //     "https://zengcai.obs.cn-north-4.myhuaweicloud.com/2023-10-17%2F599341fd628f407199348a249a17be02.jpeg",
        //   description:
        //     "宁夏菲麦森工业软件技术有限公司宁夏菲麦森工业软件技术有限公司宁夏菲麦森工业软件技术有限公司宁夏菲麦森工业软件技术有限公司", // 描述
        //   linkMethod: "李先生 13856489654", // 联系方式
        //   caseList: [
        //     { title: "专家服务案例" },
        //     { title: "装备制造行业智能工厂数字化系统间集成" },
        //   ], // 典型案例列表
        //   capabilityList: [
        //     { title: "方案规划" },
        //     { title: "精益管理咨询" },
        //     { title: "数字化车间设计" },
        //   ], // 能力列表
        // },
      ], // 服务商列表
    }
  },
  watch: {},
  computed: {},
  created() { },
  mounted() {
    this.getServiceTypeList() // 获取服务商分类列表
  },
  methods: {
    // 获取服务商分类列表
    getServiceTypeList() {
      getServiceTypeList().then((res) => {
        if (res && res.length > 0) {
          this.serviceTypeList = res
          this.getServiceList(res[0].uuid) // 默认展示第一类服务商的信息
        } else {
          this.serviceTypeList = []
        }
      })
    },
    // 获取服务商列表
    getServiceList(uuid) {
      getServiceList({
        status: 1,
        rec: 1,
        programUuid: uuid,
      }).then((res) => {
        if (res && res.length > 0) {
          this.serviceList = res
        } else {
          this.serviceList = []
        }
      })
    },
    // 点击进入服务商详情
    onClickDetail(uuid) {
      let routeData = this.$router.resolve({
        path: "/providerDetail",
        query: {
          uuid: uuid,
          type: "provider",
          titleName: "直播列表",
          titleForm: "providerDetail",
        },
      })
      window.open(routeData.href, "_blank")
    },
    // 点击进入案例详情页
    goCaseDetail(uuid) {
      let routeData = this.$router.resolve({
        path: "/caseDetail",
        query: {
          uuid: uuid,
        },
      })
      window.open(routeData.href, "_blank")
    },
    handleClick(tab, event) {
      // console.log(tab.index)
      let index = tab.index
      this.getServiceList(this.serviceTypeList[index].uuid)
    },
  },
}
</script>
<style lang="less" scoped>
.serviceProvider {
  height: 506px;
  margin: auto;
  background-color: #fff;

  /deep/ .el-carousel__arrow {
    // background-color: rgba(31, 45, 61, .11);
    box-shadow: 0 0 3px #999999;
  }

  .curp {
    &:hover {
      cursor: pointer;
      color: #2d50a1;
    }
  }

  .over-num-lines {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .num4-lines {
    -webkit-line-clamp: 4;
  }

  .service {
    width: 200px;
    letter-spacing: 2px;
    font-size: 28px;
    font-weight: 600;
    padding: 10px 0;
    margin: 0 auto;
    text-align: center;
  }

  .service-box {
    box-sizing: border-box;

    .serviceItem {
      height: 380px;
      width: 1300px;
      margin: 0 auto;
      margin-top: 5px;
      box-sizing: border-box;
      border-radius: 16px;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-self: stretch;
      // box-shadow: 0 0 8px #99999947;
      border: 1px solid #efefef;

      .serviceItem-bg {
        width: 550px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        border-top-left-radius: 16px;
        border-bottom-left-radius: 16px;
      }

      .serviceItem-con {
        flex: 1;
        display: flex;
        flex-flow: column nowrap;
        justify-content: start;
        align-items: start;
        padding: 0 20px;

        .warp1 {
          .wrap1-title {
            color: #2d50a1;
            font-size: 22px;
            font-weight: 600;
          }
        }
      }
    }
  }
}

/deep/ .wrap1-title {
  color: #2d50a1;
  font-size: 22px;
  font-weight: 600;
  margin: 5px 0;
}

/deep/ .wrap3 {
  font-size: 16px;

  div {
    margin-top: 10px;
  }

  .wrap3-con {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    height: 40px;
    overflow: hidden;

    .ability {
      display: flex;
      flex-flow: row wrap;
      margin: 5px 0;

      .abilityText {
        margin: 0 5px;
        padding: 4px 10px;
        background-color: #2d50a130;
        color: #2d50a1;
        border-radius: 6px;
      }
    }
  }
}

/deep/ .wrap1-url {
  color: #ababab;
}

/deep/ .wrap1 {
  margin-top: 10px;
}

/deep/ .wrap2 {
  margin-top: 20px;
  color: #545454;
  font-size: 14px;
  line-height: 22px;
  height: 90px;
}

/deep/ .wrap4 {
  width: 120px;
  height: 34px;
  border-radius: 8px;
  // background-color: #2d50a1;
  color: #2d50a1;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
  letter-spacing: 1px;
  font-size: 14px;
  align-self: end;
}

/deep/ .el-tabs__header {
  padding-bottom: 10px;
  position: relative;
  width: 1300px;
  margin: auto !important;
}

/deep/ .el-carousel__arrow--left {
  left: 15px;
}

/deep/ .el-carousel__arrow--right {
  right: 15px;
}

/deep/ .el-tabs__nav {
  // transform: translateX(-50%) !important;
  //   left: 50%;
  font-size: 24px;
  font-weight: bold;
}

/deep/ .el-tabs__item {
  font-size: 18px !important;
  font-weight: 500;
  padding: 0px;
  margin: 0 15px;
}

/deep/ .el-tabs__item:hover {
  color: #2d50a1;
  cursor: pointer;
}

/deep/ .el-tabs__item.is-active {
  color: #2d50a1;
  box-shadow: 0 -3px 0 #2d50a1 inset;
}

/deep/ .el-tabs__active-bar {
  background-color: transparent;
}

/deep/ .el-carousel__container {
  height: 410px;
}

/deep/ .el-tabs__header::after {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/resourcePool/serviceProvider.vue